var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyEth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4298 0.00146484L14.2461 0.625616V18.7354L14.4298 18.9188L22.8361 13.9498L14.4298 0.00146484Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4299 0.00146484L6.02344 13.9498L14.4299 18.9188V10.1288V0.00146484Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4317 20.5104L14.3281 20.6366V27.0876L14.4317 27.39L22.843 15.5439L14.4317 20.5104Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4299 27.39V20.5104L6.02344 15.5439L14.4299 27.39Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4297 18.9184L22.8359 13.9494L14.4297 10.1284V18.9184Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02344 13.9494L14.4299 18.9184V10.1284L6.02344 13.9494Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8178,
    height: 27.3887,
    fill: "white",
    transform: "translate(6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyEth);
export default __webpack_public_path__ + "static/media/Currency=ETH.4a5af937185ba1210df2ebecf41fe7e4.svg";
export { ForwardRef as ReactComponent };